import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { useTimeZone } from '../../../../../hooks'
import { BirdviewCard } from '../../../../DashboardBirdview'
import {
  OVERVIEW_PANEL_ROW_BY_FIELD,
  OVERVIEW_PANEL_SHOW_ALL_BY_FIELD,
} from '../RentalPortalOverviewPanels.constants'
import {
  getIsOverviewPanelTruncated,
  getOverviewPanelRows,
  getOverviewPanelState,
} from '../RentalPortalOverviewPanels.utils'

import {
  getOverviewPanelBody,
  getOverviewPanelCardState,
} from './RentalPortalOverviewPanel.utils'

function RentalPortalOverviewPanel({
  dragHandleProps,
  isLoading,
  overview,
  panel,
  onRetry,
}) {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const timezone = useTimeZone()

  const { emptyTextKey, field, qaName, rowKeyFields, titleKey, totalField } =
    panel
  const rows = overview?.[field]
  const total = overview?.[totalField]
  const state = getOverviewPanelState({ isLoading, rows })
  const getShowAllLink = OVERVIEW_PANEL_SHOW_ALL_BY_FIELD[field]

  function handleShowAll() {
    navigate(getShowAllLink({ overview, timezone }))
  }

  return (
    <BirdviewCard
      count={total}
      dragHandleProps={dragHandleProps}
      hasMore={getIsOverviewPanelTruncated({ rows, total })}
      qaName={qaName}
      state={getOverviewPanelCardState(state)}
      title={t(titleKey)}
      onRetry={onRetry}
      onShowAll={getShowAllLink ? handleShowAll : null}
    >
      {getOverviewPanelBody({
        children: getOverviewPanelRows({
          Row: OVERVIEW_PANEL_ROW_BY_FIELD[field],
          rowKeyFields,
          rows,
        }),
        emptyText: t(emptyTextKey),
        state,
      })}
    </BirdviewCard>
  )
}

export default RentalPortalOverviewPanel
